@use '@/scss/underscore' as _;

.resourceLayout {
  height: 100%;
}
